import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Listbox } from 'primeng/listbox';
import { Table } from 'primeng/table';
import { checkFieldsValidity } from '../../shared/index';
import { ManageBidInstructionService } from '../manage-bid-instruction.service';
import { BidInstructionChangeLog, BidInstructionChangeLogSearchParams } from '../models';

@Component({
  selector: 'app-change-log-bid-instruction',
  templateUrl: './change-log-bid-instruction.component.html',
  styleUrls: ['./change-log-bid-instruction.component.scss']
})
export class ChangeLogBidInstructionComponent implements OnInit, OnChanges {

  @ViewChild('dt') table: Table;
  @Output() closeDialog = new EventEmitter<boolean>();
  @Input() showDialog: boolean;

  // Take the List box references
  @ViewChild('listboxChangedBy') listboxChangedBy: Listbox;
  @ViewChild('listboxTrsustee') listboxTrsustee: Listbox;
  @ViewChild('listboxStates') listboxStates: Listbox;

  changedBy: any[];
  states: any[];
  trustee: any[];
  selectedChangedByUsers: any[];
  selectedTrustee: any[];
  selectedStates: any[];
  changedBySelectorDisabled = true;
  changedBySelectorFilter = false;
  changeLogForm: FormGroup;
  minDate: Date;
  maxDate: Date;
  disableChangeLogForm: boolean;
  data: BidInstructionChangeLog[];
  showChangeByCheckBox: boolean = true;
  disableChangeLogCheckBox: boolean = false;
  showStateCheckBox: boolean = true;
  disableStateCheckBox: boolean = false;
  showTrusteeCheckBox: boolean = true;
  disableTrusteeCheckBox: boolean = false;
  showChangedbyFilter: boolean = true;
  showStatesFilter: boolean = true;
  showTrusteeFilter: boolean = true;
  reqParms: BidInstructionChangeLogSearchParams;
  records: number;
  cols: any[];
  loading: boolean;
  formSubmitted: boolean;
  first: number;

  constructor(private manageBidInstructionService: ManageBidInstructionService) { }

  ngOnChanges() {
    this.resetForm();
  }

  ngOnInit() {
    this.changedBy = [{ name: 'Loading..', code: 'Loading..' }];
    this.states = [{ name: 'Loading..', code: 'Loading..' }];
    this.trustee = [{ name: 'Loading..', code: 'Loading..' }];

    this.changeLogForm = new FormGroup({
      changedBy: new FormControl('', null),
      states: new FormControl('', null),
      trustees: new FormControl('', null),
      toDate: new FormControl('', null),
      fromDate: new FormControl('', null)
    }, checkFieldsValidity(Validators.required));

    this.formSubmitted = false;
    this.formControlValueChanged();
    this.manageBidInstructionService.getSelectorsData().subscribe(res => {
      res.data[0].ChangedBy.length == 0 ? (this.changedBy = [{ name: 'No data', Code: 'No data' }], this.showChangeByCheckBox = false, this.disableChangeLogCheckBox = true, this.showChangedbyFilter = false) : (this.changedBy = res.data[0].ChangedBy);
      res.data[0].States.length == 0 ? (this.states = [{ name: 'No data', Code: 'No data' }], this.showStateCheckBox = false, this.disableStateCheckBox = true, this.showStatesFilter = false) : (this.states = res.data[0].States);
      res.data[0].Trustees.length == 0 ? (this.trustee = [{ name: 'No data', Code: 'No data' }], this.showTrusteeCheckBox = false, this.disableTrusteeCheckBox = true, this.showTrusteeFilter = false) : (this.trustee = res.data[0].Trustees);
    });

    this.cols = [
      { field: 'CRUDDate', header: 'Changed Date', showInHeader: true },
      { field: 'ChangeByName', header: 'Changed By', showInHeader: true },
      { field: 'TrusteeName', header: 'Trustee Name', showInHeader: true },
      { field: 'StateName', header: 'Property state', showInHeader: true },
      { field: 'BidMatrixAuditId', header: 'BidMatrix Audit Id', showInHeader: false },
      { field: 'BidMatrixId', header: 'Bid matrix Id', showInHeader: false },
      { field: 'CurrentBidInstructionDocsIncluded', header: 'Current BidInstruction Docs Included', showInHeader: false },
      { field: 'PreviousBidInstructionDocsIncluded', header: 'Previous BidInstruction Docs Included', showInHeader: false },
      { field: 'CurrentCOSAltisourceCopyIncluded', header: 'Current COS Altisource Copy Included', showInHeader: false },
      { field: 'PreviousCOSAltisourceCopyIncluded', header: 'Previous COS Altisource Copy Included', showInHeader: false },
      { field: 'CurrentCOSBuyerCopyIncluded', header: 'Current COS Buyer Copy Included', showInHeader: false },
      { field: 'PreviousCOSBuyerCopyIncluded', header: 'Previous COS Buyer Copy Included', showInHeader: false },
      { field: 'CurrentAltisourceBidSheetIncluded', header: 'Current Altisource BidSheet Included', showInHeader: false },
      { field: 'PreviousAltisourceBidSheetIncluded', header: 'Previous Altisource BidSheet Included', showInHeader: false },
      { field: 'CurrentBidInstructionFilePath', header: 'Current BidInstruction File Path', showInHeader: false },
      { field: 'PreviousBidInstructionFilePath', header: 'Previous BidInstruction FilePath', showInHeader: false },
      { field: 'CurrentBidInstructionFileName', header: 'Current BidInstruction File Name', showInHeader: false },
      { field: 'PreviousBidInstructionFileName', header: 'Previous BidInstruction FileName', showInHeader: false },
      { field: 'CurrentBidInstructionFileId', header: 'Current BidInstruction FileId', showInHeader: false },
      { field: 'PreviousBidInstructionFileId', header: 'Previous BidInstruction FileId', showInHeader: false },

      { field: 'CurrentFileUploadDate', header: 'Current BidInstruction File Upload Date', showInHeader: false },
      { field: 'PreviousFileUploadDate', header: 'Previous BidInstruction File Upload Date', showInHeader: false }
    ];

  }

  isPaginatorVisible(): boolean {
    return (this.data && this.data.length > 0) ? true : false;
  }

  dialogHide() {
    this.closeDialog.emit(true);
  }


  setDateRange(days: number): void {
    let tempDate = new Date();
    tempDate.setDate(tempDate.getDate() - days);
    this.minDate = tempDate;
    this.maxDate = new Date();
  }

  formControlValueChanged() {
    this.changeLogForm.get('fromDate').valueChanges.subscribe(
      (newDate: Date) => {
        if (newDate != null && this.maxDate == null) {
          this.disableChangeLogForm = true;
        } else if (newDate > this.maxDate) {
          this.disableChangeLogForm = true;
        } else {
          this.disableChangeLogForm = false;
        }
      });

    this.changeLogForm.get('toDate').valueChanges.subscribe(
      (newDate: Date) => {
        if (newDate != null && this.minDate == null) {
          this.disableChangeLogForm = true;
        } else if (newDate < this.minDate) {
          this.disableChangeLogForm = true;
        } else {
          this.disableChangeLogForm = false;
        }
      });
  }

  resetForm() {
    if (this.changeLogForm != undefined) {
      this.changeLogForm.reset();
      this.data = [];
      this.formSubmitted = false;
      this.listboxChangedBy.filterValue = '';
      this.listboxStates.filterValue = '';
      this.listboxTrsustee.filterValue = '';
    }

  }
  onSubmitChangeLogForm() {
    this.data = [];
    this.reqParms = <BidInstructionChangeLogSearchParams>{};
    this.reqParms.ChangedBy = this.formatParams(this.changeLogForm.value.changedBy);
    this.reqParms.StateCode = this.formatParams(this.changeLogForm.value.states);
    this.reqParms.TrusteeId = this.formatParams(this.changeLogForm.value.trustees);
    this.reqParms.ToDate = this.changeLogForm.value.toDate == null ? '' : this.formatDate(this.changeLogForm.value.toDate);
    this.reqParms.FromDate = this.changeLogForm.value.fromDate == null ? '' : this.formatDate(this.changeLogForm.value.fromDate);
    this.loading = true;
    this.formSubmitted = true;
    // Reset the paginator
    this.table.first = 0;

    this.manageBidInstructionService.getChangeLogData(this.reqParms).subscribe(res => {
      this.data = res.data;
      this.records = res.meta.pagination.TotalRecords;
      this.loading = false;
    });
  }

  formatParams(data): string {
    const formattedList = [];
    if (data) {
      data.map(item => {
        formattedList.push(item.code);
      });
    }
    return formattedList.toString();
  }

  formatDate(dateObj: Date): string {
    let current_datetime = dateObj;
    let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate();
    return formatted_date;
  }

  downloadBidInstructions(BidMatrixId?: any): any {
    let stInfo = this.manageBidInstructionService.downloadBidInstructionFile(BidMatrixId);
    stInfo.then((data) => {
      if (!data.success) {
        console.log('Error Occured During Downloadd');

      }
    });
  }
}

